"use client";
import styles from "./HubspotForm.module.css";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokHubspotForm } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import Script from "next/script";
import { useCallback, useEffect, useId, useState } from "react";

import { clsx } from "@frend-digital/ui";

export const HubspotFormBlok = ({ blok }: BlokProps<BlokHubspotForm> & { className?: string }) => {
	if (!blok.formId || !blok.hubspotSpaceId) {
		console.error("HubspotFormBlok: Missing required formId or hubspotSpaceId");
		return <div>Missing form configuration</div>;
	}

	const [loaded, setLoaded] = useState(false);
	const id = useId();
	const formattedId = id.replaceAll(":", "_");
	const formId = blok.formId;
	const hubspotSpaceId = blok.hubspotSpaceId;

	const createForm = useCallback(() => {
		if (window.hbspt) {
			window.hbspt.forms.create({
				formId: formId,
				portalId: hubspotSpaceId,
				target: `#${formattedId}`,
				cssClass: "hubspot-form",
			});
		}
	}, [formId, formattedId, hubspotSpaceId]);

	useEffect(() => {
		if (!loaded) return;
		createForm();
	}, [createForm, loaded]);

	return (
		<BlokWrap editable={blok} className={styles.root}>
			<div id={formattedId} className={clsx(styles.hubspotForm, "hubspot-form")} />
			<Script
				data-hbst-target={id}
				onLoad={() => {
					setLoaded(true);
				}}
				src="https://js.hsforms.net/forms/v2.js"
			/>
		</BlokWrap>
	);
};
